import { useSelector } from 'react-redux';
import { getCountryCode, selectUserSession } from '@Redux/selectors';
import { getFlagValue, isFlagEnabled } from '@Redux/actions/flagsmith';
import { UNIFORM_REFERRAL_FLAG } from '../utils/constants';

export interface UniformReferralConfig {
  isEnabled: boolean;
  redeemHighValueTransfer: boolean;
}

const useUniformReferralEnabled = (): UniformReferralConfig => {
  const countryCode = useSelector(getCountryCode);
  const { email } = useSelector(selectUserSession);

  if (!isFlagEnabled(UNIFORM_REFERRAL_FLAG)) {
    return { isEnabled: false, redeemHighValueTransfer: false };
  }

  const data = getFlagValue(UNIFORM_REFERRAL_FLAG);
  const countryConfig = data?.[countryCode];
  if (!countryConfig) return { isEnabled: false, redeemHighValueTransfer: false };

  const { whiteListedUsers = [], redeemHighValueTransfer = false } = countryConfig;
  const isEnabled = whiteListedUsers.length > 0 ? whiteListedUsers.includes(email) : true;

  return { isEnabled, redeemHighValueTransfer };
};

export default useUniformReferralEnabled;
